import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
} from "@chakra-ui/react";
import { crm } from "../../../../theme";
import { useEffect } from "react";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  useEffect(() => {}, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader borderBottom={crm.border}>Confirmar encerramento</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Tem certeza que deseja marcar este processo como{" "}
          <strong>ENCERRADO</strong>? 
        </ModalBody>
        <ModalFooter gap="8px" borderTop={crm.border}>
          <Button variant="outline" borderColor={crm.border} color={crm.text} borderRadius="10px" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            backgroundColor={crm.brand}
            _hover={{ backgroundColor: crm.brandDark }}
            color="white"
            borderRadius="10px"
            onClick={onConfirm}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
